
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		show: Boolean,
		settings: {
			type: Object as ()=>ExtraFieldNamesConfig,
			required: true
		}
	},
	computed: {
		fields():ISelectItem<string>[]{
			return this.settings.getFieldsEditableViaBrowseMenuMenuItems(true);
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		selectField(item:string){
			this.$emit("confirm", item);
			this.cancel();
		}
	}
});
